import React from 'react';
import TemplatePage from '../../../components/templatePage';
import PaymentItem from '../../components/paymentItem';
import { useDispatch, useSelector } from 'react-redux';
import { setGetReplenishment } from '../../store/thunk/setGetReplenishment';
import {isArray} from 'lodash';
import { setLoadingAction } from '../../../components/templatePage/store/action';
import { setGetReplenishmentAction } from '../../store/action';
import moment from 'moment';

const handleLoadPagination = ({page, setPage, countPage}) => {
    if (page <= countPage) {
        setPage(page + 1);
    }
}

const handleLoading = (dispatch) => {
    dispatch(setLoadingAction(true))
}

const Payment = () => {
    const utc = moment.utc().valueOf();
    const dispatch = useDispatch();
    const [page, setPage] = React.useState(1);
    const [current_date, setCurrentDate] = React.useState(utc)
    const [search, setSearch] = React.useState('');
    const [startDate, setStartDate] = React.useState(0);

    React.useEffect(() => {
        dispatch(setGetReplenishment({
            page: 1, 
            rowsPerPage: (page + 1) * 50,
            search,
            date_from: startDate,
            date_to: current_date
        }));
    }, [search, startDate, current_date, page])

    const list = useSelector(state => state.replenishmentMobile.replenishment)

    return (
        <TemplatePage
            title="Отчет по платежам"
            pagination={page < list.countPage && list.data.length}
            handleLoadPagination={() => handleLoadPagination({
                page,
                setPage,
                countPage: list.countPage,
            })}
            handleLoading={() => handleLoading(dispatch)}
            datePicker
            changeDate={({date_from, date_to}) => {
                dispatch(setGetReplenishmentAction({
                    data: [],
                    countPage: 1
                }));
                setStartDate(date_from);
                setCurrentDate(date_to);
                setPage(0)
            }}
            search={true}
            searchValue={search}
            onChangeSearch={(v) => {
                dispatch(setGetReplenishmentAction({
                    data: [],
                    countPage: 1
                })); 
                setSearch(v)
                setPage(0)
            }}
        >
            {
               list.data.map((item) => <PaymentItem item={item} array={isArray(item)}/>)
            }   
            {
                !list.data.length && <span style={{width: '100%', color: '#fff', display: 'flex', justifyContent: 'center', padding: 20}}>Информация отсутствует</span>
            }
        </TemplatePage>
    )
}

export default Payment;